import restify from './restify';

const service = {
  ...restify('settings'),
};

export default service;
